import { AuctionApi, CollectibleApi, FanShopApi, getHttpClient } from '@capsicum/common';

export const fanShopApi = getHttpClient.then(c => new FanShopApi(c));
export const collectiblesApi = getHttpClient.then(c => new CollectibleApi(c));
export const rpAuctions = getHttpClient.then(c => new AuctionApi(c));
